import {forwardRef, Ref} from 'react';
import moment from 'moment';
import {FormControl} from '@mui/material';
import {MobileDatePicker, MobileTimePickerProps} from '@mui/x-date-pickers';
import {DailyCareInput} from '../daily-care-input';
import {MdOutlineCalendarMonth} from 'react-icons/md';

interface DailyCareDateInputProps extends MobileTimePickerProps<Date> {
  id?: string;
  label?: string;
  required?: boolean;
  errors?: string;
}

export const DailyCareDateInput = forwardRef(
  (
    {label, required, disabled, errors, ...rest}: DailyCareDateInputProps,
    ref: Ref<HTMLInputElement>
  ) => {
    return (
      <FormControl className="flat-starts-at-time" sx={{width: '100%', ...rest.sx}}>
        <MobileDatePicker
          {...rest}
          // @ts-ignore
          value={moment(rest.value)}
          label={label}
          slots={{
            textField: ({value, onChange, onBlur, onClick, inputProps}) => {
              return (
                <DailyCareInput
                  {...{onChange, onBlur, disabled, label, required}}
                  ref={ref}
                  onClick={onClick}
                  inputProps={{
                    ...inputProps,
                    // @ts-ignore
                    value: value,
                  }}
                  shrinkLabel={true}
                  startAdornment={<MdOutlineCalendarMonth size={22} style={{marginRight: '8px'}} />}
                />
              );
            },
          }}
        />
      </FormControl>
    );
  }
);
